'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import { Center, Container, Group, Stack, Text, Title } from '@mantine/core';

// UI local components
import BrandTag from '@ui-kit/atoms/BrandTag';

// Types
import { PageProps } from '@ui-kit/organisms/Page/types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

/**
 * Not found static error page
 */
function PageNotFound(props: PageProps<any>) {
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation('Common');

  /* ******************************** RENDERING ******************************* */
  return (
    <Container h="100vh" bg="blackroomBlack" c="white" fluid>
      <Center h="100%" w="100%">
        <Stack gap="10vh" h="100%" align="center" justify="center">
          <BrandTag withLogo withText />
          <Group mb="xl">
            <Title fw="bold" order={4}>
              {t('errors.404.title')}
            </Title>
            <Text c="blackroomGray" size="xl">
              - 404
            </Text>
          </Group>
        </Stack>
      </Center>
    </Container>
  );
}

export default PageNotFound;
